import React from 'react';
import { IconProps } from '.';

const SvgCartMove = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22.427 6.34 15.5 9.804V13H14V2.126l8.427 4.214Zm-3.354 0L15.5 4.554v3.572l3.573-1.786Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M6.62 6.75h4.88v1.5H6.786l.827 7.5h10.679l1.69-5.75h1.565l-2.133 7.25H6.27l-1.323-12H1.5v-1.5h4.79l.33 3ZM22.502 6.75l-.002.008V6.75h.002ZM11 20a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16.5 21.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
    </svg>
  );
};

export default SvgCartMove;
